<template>
  <div class="QCReportPage">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50" align="center" :index="pagination.beginIndex"></el-table-column>
      <el-table-column prop="sn" label="SN" align="center" sortable="custom" min-width="120">
        <template slot-scope="scope">          
          <el-tooltip class="item" effect="dark" :content="scope.row.sn ? scope.row.sn : '-'" placement="top" :open-delay="300">
            <div class="textOverflow">
              {{ scope.row.sn ? scope.row.sn : "-" }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="workStation" label="工序" align="center" show-overflow-tooltip sortable="custom" min-width="110px">
        <template slot-scope="scope">
          <span v-if="scope.row.workStation">{{scope.row.workStation.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="测试类型" align="center" min-width="110" show-overflow-tooltip sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="targetType" label="被测对象" align="center" show-overflow-tooltip sortable="custom" min-width="110px">
        <template slot-scope="scope">
          <span v-if="scope.row.targetType">{{ scope.row.targetType }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="this.orderDetailData && this.orderDetailData.product && this.orderDetailData.product.productType && this.orderDetailData.product.productType.code=='HEADPHONE'"
        prop="partName" label="对象名称" align="center" min-width="180px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.partName">{{ scope.row.partName + (scope.row.partType ? (" - " + scope.row.partType) : "")}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="organization" label="线体" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.organization">{{ scope.row.organization.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="tester" label="员工" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.tester">{{ scope.row.tester.name }} ({{scope.row.tester.employeeNum}})</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDateTime" label="测试时间" align="center" show-overflow-tooltip min-width="110px">
        <template slot-scope="scope">
          <span v-if="scope.row.createDateTime">{{ scope.row.createDateTime }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="code" label="错误代码" align="center" show-overflow-tooltip sortable="custom" min-width="110px">
        <template slot-scope="scope">
          <span :class="{danger: scope.row.code != 0}">{{scope.row.code}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="code" label="测试结果" align="center" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.msg">{{ scope.row.msg }}</span>
          <span v-else>{{ scope.row.code == 0 ? "成功" : "失败" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="logFile" label="日志" width="60px" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="allowSkip" v-if="scope.row.logFile" @click="QCDownload(scope.row)" >下载</span>
          <span class="allowSkip" v-else @click="QCExamine(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getProOrderQCReport"></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import { apiSmtOrderDetail } from "@/api/SmtOrder.js";
import { apiQCShowLog, apiProOrderQCReport} from "@/api/qcRecord.js";
export default {
  components: {
    pagination,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    QCReportForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderDetailData: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  methods: {
    // 表格数据
    async getProOrderQCReport(remove, callback) {
      if (!this.orderDetailData) {
        const res = await apiSmtOrderDetail({
          id: this.tabPaneValue,
        });
        if (res.code == 0) {
          this.orderDetailData = res.data;
        }
      }
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProOrderQCReport({
        productionOrderId: this.tabPaneValue,
        ...this.QCReportForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // QC下载
    QCDownload(row) {
      let a = document.createElement("a");
      a.download = row.partName;
      a.href = row.logFile;
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // QC查看
    async QCExamine(row) {
      const res = await apiQCShowLog({
        id: row.id,
      });
      if (res.code == 0) {
        // this.$alert(res.data, "查看日志", {
        //   confirmButtonText: "确定",
        // });
        const h = this.$createElement;
        this.$msgbox({
          title: '查看日志',
          message: h('div', null, [
            h('pre', null, JSON.stringify(res.data, null, '\t'))
          ]),
          confirmButtonText: '确定'
        })
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProOrderQCReport();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProOrderQCReport();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProOrderQCReport();
    },
    // QC导出
    QCReportExport(fqc) {
      this.$confirm(`导出QC日志需要消耗较大的系统资源，建议在非生产时段导出。请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProOrderQCReport({
          productionOrderId: this.tabPaneValue,
          ...this.QCReportForm,
          export: true,
          desc: this.desc,
          orderBy: this.orderBy,
          fqc
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.QCReportPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
